<template>
  <MainPage :withArticles="false" :withEvents="false" v-if="loaded">
    <div class="memories-page">
      <div class="page-wrapper">
        <div class="top-info">
          <div class="top-info__title">
            Have You Experienced East Lake?
          </div>
        </div>
        <div class="top-info__description">
          <p>
            You miss East Lake, and we miss having you. But you can still be a
            part of our story! Show off your East Lake pride, tell us about the
            hidden gems, or share the memories that make you can't wait to come
            back next year.
          </p>
        </div>
        <br />
        <div class="text-center">
          <v-btn
            @click="openNewMemoryDialog"
            elevation="0"
            large
            class="share-memory-btn"
            >Share a memory of east lake</v-btn
          >
          <v-dialog
            persistent
            max-width="990"
            v-if="memoryPageDialog"
            v-model="memoryPageDialog"
          >
            <v-card>
              <MemoryForm @close="memoryPageDialog = false" />
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div class="memories-page__grid">
        <div ref="grid">
          <!--<SearchInput v-model="search" />-->
          <Grid :items="memories" />
          <infinite-loading :identifier="infiniteId" @infinite="fetchMemories">
            <div slot="no-more"></div>
            <div slot="no-results" class="no-results">Nothing found</div>
            <div slot="spinner">
              <Spinner />
            </div>
          </infinite-loading>
        </div>
      </div>
    </div>
  </MainPage>
</template>

<script>
import _ from "lodash";
import MemoryForm from "@/components/Memory/MemoryForm";
import MainPage from "./main.page";

export default {
  name: "MemoriesPage",
  metaInfo: {
    titleTemplate: "%s - Memories",
  },
  components: { MemoryForm, MainPage },
  data() {
    return {
      search: "",
      memories: [],
      page: 1,
      infiniteId: +new Date(),
      pageIds: [],
      memoryPageDialog: false,
      showTags: false,
      loaded: false,
    };
  },
  created() {
    this.setPageContext("stories", () => {
      this.loaded = true;
    });
  },
  methods: {
    openNewMemoryDialog() {
      this.memoryPageDialog = true;
    },
    async fetchMemories($state) {
      const params = {
        page_ids: this.pageIds,
        page: this.page,
        query: this.search,
        self_posted: false,
      };
      const { data } = await this.$api.Memory.query(params);
      this.page += 1;
      const ids = this.memories.map((t) => t.id);
      const newData = data.filter((t) => !ids.includes(t.id));

      this.memories.push(...newData);

      if (data.length) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    setInfiniteId: _.debounce(function() {
      this.page = 1;
      this.memories = [];
      this.infiniteId += 1;
    }, 300),
  },
  watch: {
    search() {
      this.setInfiniteId();
    },
  },
};
</script>

<style scoped lang="scss">
.memories-page {
  &__grid {
    margin-top: 60px;
    min-height: 200px;
    position: relative;
  }
}
.top-info__title {
  font-family: "Roboto Condensed";
  font-weight: 700;
  margin-bottom: 0;
}
.top-info__description {
  max-width: 700px;
  margin: 0 auto;
}

.text-center::v-deep
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  color: $primary;
  background-color: white;
  border: 2px solid $primary;
  letter-spacing: 0;
}

@media screen and (max-width: 960px) {
  .memories-page {
    &__grid {
      margin-top: -20px;
      margin-bottom: 40px;
    }
  }
}
</style>
